import { AxiosInstance } from "axios";
import ApiClient from "./ApiClient";
import {
  Campaign,
  CampaignInfo,
  CampaignUpdateDTO,
} from "../types/Campaign";

// Mentoring Fusion API base URL
const API_URL = process.env.REACT_APP_MENTORING_API_URL ?? "";

class CampaignService {
  private apiClient: AxiosInstance;

  constructor() {
    this.apiClient = new ApiClient(API_URL).getClient();
  }

  /* -------------------------------------------------------------------------- */
  /*                               List/Create                                  */
  /* -------------------------------------------------------------------------- */

  public listCampaigns = async (
    organizationId: string
  ): Promise<CampaignInfo[]> => {
    const response = await this.apiClient.get<CampaignInfo[]>(
      `/organizations/${organizationId}/campaigns`
    );
    return response.data;
  };

  public createCampaign = async (
    organizationId: string,
    payload: CampaignUpdateDTO
  ): Promise<Campaign> => {
    const response = await this.apiClient.post<Campaign>(
      `/organizations/${organizationId}/campaigns`,
      payload
    );
    return response.data;
  };

  /* -------------------------------------------------------------------------- */
  /*                               Get/Update                                   */
  /* -------------------------------------------------------------------------- */

  public getCampaign = async (
    organizationId: string,
    campaignId: string
  ): Promise<Campaign> => {
    const response = await this.apiClient.get<Campaign>(
      `/organizations/${organizationId}/campaigns/${campaignId}`
    );
    return response.data;
  };

  public updateCampaign = async (
    organizationId: string,
    campaignId: string,
    updates: CampaignUpdateDTO
  ): Promise<Campaign> => {
    const response = await this.apiClient.patch<Campaign>(
      `/organizations/${organizationId}/campaigns/${campaignId}`,
      updates
    );
    return response.data;
  };

  /* -------------------------------------------------------------------------- */
  /*                                    Delete                                   */
  /* -------------------------------------------------------------------------- */

  public deleteCampaign = async (
    organizationId: string,
    campaignId: string
  ): Promise<void> => {
    await this.apiClient.delete(
      `/organizations/${organizationId}/campaigns/${campaignId}`
    );
  };
}

const campaignService = new CampaignService();
export default campaignService;
